module.exports = wtr_shared_19_2_5;